import type { ReactNode } from 'react'

/**
 * Bidi isolation for gate codes, phone numbers, protocol strings, and timestamps (§7.2,
 * non-negotiable), ported from `prototype/screens/shared.js`'s `bidi()`. `unicode-bidi:
 * isolate` plus a forced `dir="ltr"` keeps an LTR token legible inside an RTL sentence
 * without a raw `<bdi>` scattered through every screen.
 */
export function Bidi({ children }: { readonly children: ReactNode }): JSX.Element {
  return (
    <bdi className="bidi" dir="ltr">
      {children}
    </bdi>
  )
}
